import { Center, Loader } from "@mantine/core";
import { useEffect, useState } from "react";

import { hydrateStaffSession } from "@/features/auth/lib/auth-session";

export function StaffSessionGate({ children }: { children: React.ReactNode }) {
	const [ready, setReady] = useState(false);

	useEffect(() => {
		void hydrateStaffSession()
			.catch(() => undefined)
			.finally(() => setReady(true));
	}, []);

	if (!ready) {
		return (
			<Center mih="100vh">
				<Loader />
			</Center>
		);
	}

	return children;
}
